module.exports = __webpack_public_path__ + "static/content_4_1_do-d31e82db2cb43e82fadd95cb2ce034ae.png";